/**
 * 公司文档  api
 */
import * as API from '../'

// 服务名称
let serviceName = '/clouddo-tranning';

export default {
  /**
   * 公司文档列表
   */
  employeeFileList: params => {
    return API.GET(serviceName + `/tranning/employee/file/page_list`, params)
  },
  /**
   * 文档详情
   */
  employeeFiledetails: params => {
    return API.GET(serviceName + `/tranning/employee/file/details`, params)
  },
  /**
   * 保存文档
   */
  employeeFileSave: params => {
    return API.POST(serviceName + `/tranning/employee/file/save`, params)
  },
  /**
   * 删除文档数据
   */
  employeeFileDelete: params => {
    return API.POST(serviceName + `/tranning/employee/file/delete`, params)
  },
  /**
   * 导出陪训记录
   */
  trainingRecordExport:  params => {
    return API.GET(serviceName + `/tranning/employee/file/training_record_export`, params)
  },
  /**
   * 生产经营单位从业人员调岗和重新上岗安全培训考核记录
   */
  reEmploymentTrainingRecordsExport: params => {
    return API.GETBLOB(serviceName + `/tranning/employee/file/re_employment_training_records_export`, params)
  },
  /**
   * 导出学时间证明
   */
  proofOfClassHoursExport: params => {
    return API.GET(serviceName + `/tranning/employee/file/proof_of_class_hours_export`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/new/employee_file.js